module.exports = __webpack_public_path__ + "static/media/conferencies.341c1018.jpg";